import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import { FaArrowRightLong } from 'react-icons/fa6';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import useTitle from '../../Hooks/useTitle';


const MoreProjects = () => {
    useTitle('Projects');
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        fetch('https://shakil-server.vercel.app/projects')
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                setProjects(data);
            })
    }, [])

    if (loading) {
        return <div className='flex justify-center items-center w-full min-h-[80vh] text-4xl'>
            <span className="loading text-accent loading-dots"></span>
        </div>
    }


    return (
        <div className='px-5 md:px-20 lg:px-32 py-10 max-w-[1400px] m-auto'>
            <h1 className='font-bold text-4xl text-center mb-10 tracking-widest'>All <span className='text-teal-300'>Projects</span></h1>

            {
                projects.map(project => <div className='mb-20 md:mb-20 lg:mb-32 shadow-2xl rounded pb-8' data-aos='fade-up' key={project._id}>
                    <div className='mt-20 mb-5 text-center'>
                        <Link to={project?._id} className='text-2xl font-bold text-teal-400'>{project?.name}</Link>
                        <br />
                        <Link to={project?._id} className='btn btn-xs px-20 hover:border-teal-300 mt-5 btn-outline text-teal-500 w-10'>Details</Link>
                    </div>
                    <div className='flex justify-center items-center py-5'>
                        <Swiper
                            effect={"coverflow"}
                            grabCursor={true}
                            centeredSlides={true}
                            slidesPerView={2}
                            spaceBetween={30}
                            coverflowEffect={{
                                rotate: 20,
                                stretch: 0,
                                depth: 700,
                                modifier: 1,
                                slideShadows: true,
                            }}
                            initialSlide={Math.floor(project.images.length / 2 - 1)}
                            loop={true}
                            autoplay={{
                                delay: 1500,
                                disableOnInteraction: false,
                            }}
                            modules={[Autoplay, EffectCoverflow]}
                            className="w-full"
                        >
                            {
                                project.images.map(image => <SwiperSlide className="bg-center bg-cover w-full" key={image.id}>
                                    <PhotoProvider>
                                        <PhotoView src={image?.img}>
                                            <img src={image?.img} className='w-full block h-44 md:h-80 lg:h-80  rounded' alt="" />
                                        </PhotoView>
                                    </PhotoProvider>
                                </SwiperSlide>)
                            }
                        </Swiper>
                    </div>
                    <div className='flex gap-4 md:gap-10 lg:gap-10 justify-center mt-10'>
                        <Link to={project?.liveServer} title={project?.name} className='text-xs font-bold btn btn-sm  btn-accent md:px-12 lg:px-12' target='_blank'>Live Site</Link>

                        <Link to={project?.clientSite} title={project?.name} className='text-xs font-bold btn btn-sm  btn-accent' target='_blank'>Client Site<span className='hidden md:block lg:block'>-Source Code</span></Link>
                        {
                            project.serevrSite &&
                            <Link to={project?.serevrSite} title={project?.name} className='text-xs font-bold btn btn-sm  btn-accent' target='_blank'>Server Site<span className='hidden md:block lg:block'>-Source Code</span></Link>
                        }
                    </div>
                </div>)
            }
            <div className='flex justify-center py-10'>
                <Link className='btn btn-sm btn-outline hover:border-teal-300 text-teal-300'>See More <FaArrowRightLong></FaArrowRightLong></Link>
            </div>
        </div>
    );
};

export default MoreProjects;